import React, { useContext, useState } from 'react';
import * as S from './DockLikuConnecting.style';
import Spinner from '../../spinner/Spinner';
import Image from '../../image/Image';
import { RootStoreContext } from '../../../App';
import { observer } from 'mobx-react';

const DockLikuConnecting = observer(() => {
	const { likuStore, mqttStore } = useContext(RootStoreContext);

	const [isHover, setIsHover] = useState(false);
	const isConnectionFailed = mqttStore.likuHeartBeat?.isConnectionFailed;

	return (
		<S.Content>
			<S.LinkButton
				onClick={() => likuStore.setThisLiku()}
				onMouseOver={() => setIsHover(true)}
				onMouseOut={() => setIsHover(false)}>
				<S.IconContainer>
					{isHover || isConnectionFailed ? (
						<Image srcArray={S.x_list} />
					) : (
						<Spinner color='gold' />
					)}
				</S.IconContainer>
				{isConnectionFailed ? '연결실패' : isHover ? '연결끊기' : '연결중'}
			</S.LinkButton>
		</S.Content>
	);
});

export default DockLikuConnecting;
